__turbopack_context__.v({
  "blok-big-title": "ToolSizePicker-module__86vula__blok-big-title",
  "blok-subtitle": "ToolSizePicker-module__86vula__blok-subtitle",
  "blok-title": "ToolSizePicker-module__86vula__blok-title",
  "box": "ToolSizePicker-module__86vula__box",
  "selected": "ToolSizePicker-module__86vula__selected",
  "size": "ToolSizePicker-module__86vula__size",
  "sizes": "ToolSizePicker-module__86vula__sizes",
});
